// extracted by mini-css-extract-plugin
module.exports = {"document-button":"cookie-accept_document-button__narS6","container":"cookie-accept_container__w5JQ3"};